import { render, staticRenderFns } from "./HistoryDatasetAsTable.vue?vue&type=template&id=4503bd1f&scoped=true"
import script from "./HistoryDatasetAsTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./HistoryDatasetAsTable.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./HistoryDatasetAsTable.vue?vue&type=style&index=0&id=4503bd1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4503bd1f",
  null
  
)

export default component.exports